import type { ProjectFile } from "../lib/api";

export function FileTree({
  files,
  selected,
  onSelect,
}: {
  files: ProjectFile[];
  selected: string | null;
  onSelect: (path: string) => void;
}) {
  return (
    <div className="pane">
      <div className="pane-header">Files</div>
      <div className="pane-body file-tree">
        {files.length === 0 ? (
          <div style={{ color: "var(--fg-faint)", padding: 8, fontSize: 12 }}>(empty — Claude hasn't written anything yet)</div>
        ) : (
          files.map((f) => (
            <div
              key={f.path}
              className={"file-row" + (f.path === selected ? " active" : "")}
              onClick={() => onSelect(f.path)}
            >
              {f.path}
            </div>
          ))
        )}
        {selected && files.find((f) => f.path === selected) && (
          <div className="file-viewer" style={{ marginTop: 8, maxHeight: 360 }}>
            <pre>{files.find((f) => f.path === selected)!.content}</pre>
          </div>
        )}
      </div>
    </div>
  );
}
